export const AI_PROCESS_RUNS_ACTION_TYPE = {
  LOAD_RUNS: 'aiProcessRuns/LOAD_RUNS',
  LOAD_RUNS_SUCCESS: 'aiProcessRuns/LOAD_RUNS_SUCCESS',
  LOAD_RUNS_FAILURE: 'aiProcessRuns/LOAD_RUNS_FAILURE',
  SET_RUNS_FILTER: 'aiProcessRuns/SET_RUNS_FILTER',
  SET_RUNS_PAGE: 'aiProcessRuns/SET_RUNS_PAGE',
  LOAD_PROCESSES_USED: 'aiProcessRuns/LOAD_PROCESSES_USED',
  LOAD_PROCESSES_USED_SUCCESS: 'aiProcessRuns/LOAD_PROCESSES_USED_SUCCESS',
  LOAD_PROCESSES_USED_FAILURE: 'aiProcessRuns/LOAD_PROCESSES_USED_FAILURE',
  LOAD_RUN_DETAIL: 'aiProcessRuns/LOAD_RUN_DETAIL',
  LOAD_RUN_DETAIL_SUCCESS: 'aiProcessRuns/LOAD_RUN_DETAIL_SUCCESS',
  LOAD_RUN_DETAIL_FAILURE: 'aiProcessRuns/LOAD_RUN_DETAIL_FAILURE',
  LOAD_STEP_MESSAGES: 'aiProcessRuns/LOAD_STEP_MESSAGES',
  LOAD_STEP_MESSAGES_SUCCESS: 'aiProcessRuns/LOAD_STEP_MESSAGES_SUCCESS',
  LOAD_STEP_MESSAGES_FAILURE: 'aiProcessRuns/LOAD_STEP_MESSAGES_FAILURE',
  LOAD_STEP_CITATIONS: 'aiProcessRuns/LOAD_STEP_CITATIONS',
  LOAD_STEP_CITATIONS_SUCCESS: 'aiProcessRuns/LOAD_STEP_CITATIONS_SUCCESS',
  LOAD_STEP_CITATIONS_FAILURE: 'aiProcessRuns/LOAD_STEP_CITATIONS_FAILURE',
  LOAD_RUN_CITATIONS: 'aiProcessRuns/LOAD_RUN_CITATIONS',
  LOAD_RUN_CITATIONS_SUCCESS: 'aiProcessRuns/LOAD_RUN_CITATIONS_SUCCESS',
  LOAD_RUN_CITATIONS_FAILURE: 'aiProcessRuns/LOAD_RUN_CITATIONS_FAILURE',
  LOAD_STEP_BLOB: 'aiProcessRuns/LOAD_STEP_BLOB',
  LOAD_STEP_BLOB_SUCCESS: 'aiProcessRuns/LOAD_STEP_BLOB_SUCCESS',
  LOAD_STEP_BLOB_FAILURE: 'aiProcessRuns/LOAD_STEP_BLOB_FAILURE',
  SET_STEP_GUIDELINE_FULL_VIEW: 'aiProcessRuns/SET_STEP_GUIDELINE_FULL_VIEW',
  CACHE_STEP_GUIDELINE_CONTENT: 'aiProcessRuns/CACHE_STEP_GUIDELINE_CONTENT',
  LOAD_STEP_GUIDELINE_CONTENT_FAILURE: 'aiProcessRuns/LOAD_STEP_GUIDELINE_CONTENT_FAILURE',
  LOAD_STEP_PENDING_TOOL_CALL: 'aiProcessRuns/LOAD_STEP_PENDING_TOOL_CALL',
  LOAD_STEP_PENDING_TOOL_CALL_SUCCESS: 'aiProcessRuns/LOAD_STEP_PENDING_TOOL_CALL_SUCCESS',
  LOAD_STEP_PENDING_TOOL_CALL_FAILURE: 'aiProcessRuns/LOAD_STEP_PENDING_TOOL_CALL_FAILURE',
  SET_STEP_PENDING_TOOL_CALL: 'aiProcessRuns/SET_STEP_PENDING_TOOL_CALL',
  LOAD_STEP_PENDING_QUESTION: 'aiProcessRuns/LOAD_STEP_PENDING_QUESTION',
  LOAD_STEP_PENDING_QUESTION_SUCCESS: 'aiProcessRuns/LOAD_STEP_PENDING_QUESTION_SUCCESS',
  LOAD_STEP_PENDING_QUESTION_FAILURE: 'aiProcessRuns/LOAD_STEP_PENDING_QUESTION_FAILURE',
  SET_STEP_PENDING_QUESTION: 'aiProcessRuns/SET_STEP_PENDING_QUESTION',
  ANSWER_STEP_QUESTION: 'aiProcessRuns/ANSWER_STEP_QUESTION',
  ANSWER_STEP_QUESTION_SUCCESS: 'aiProcessRuns/ANSWER_STEP_QUESTION_SUCCESS',
  ANSWER_STEP_QUESTION_FAILURE: 'aiProcessRuns/ANSWER_STEP_QUESTION_FAILURE',
  SELECT_EXECUTION: 'aiProcessRuns/SELECT_EXECUTION',
  EXECUTION_UPSERT: 'aiProcessRuns/EXECUTION_UPSERT',
  STEP_UPSERT: 'aiProcessRuns/STEP_UPSERT',
  MESSAGE_APPEND: 'aiProcessRuns/MESSAGE_APPEND',
  CONFIRM_STEP_EXECUTION: 'aiProcessRuns/CONFIRM_STEP_EXECUTION',
  CONFIRM_STEP_EXECUTION_SUCCESS: 'aiProcessRuns/CONFIRM_STEP_EXECUTION_SUCCESS',
  CONFIRM_STEP_EXECUTION_FAILURE: 'aiProcessRuns/CONFIRM_STEP_EXECUTION_FAILURE',
  RETRY_STEP_EXECUTION: 'aiProcessRuns/RETRY_STEP_EXECUTION',
  RETRY_STEP_EXECUTION_SUCCESS: 'aiProcessRuns/RETRY_STEP_EXECUTION_SUCCESS',
  RETRY_STEP_EXECUTION_FAILURE: 'aiProcessRuns/RETRY_STEP_EXECUTION_FAILURE',
  RETRY_STEP_FROM_HERE_EXECUTION: 'aiProcessRuns/RETRY_STEP_FROM_HERE_EXECUTION',
  RETRY_STEP_FROM_HERE_EXECUTION_SUCCESS: 'aiProcessRuns/RETRY_STEP_FROM_HERE_EXECUTION_SUCCESS',
  RETRY_STEP_FROM_HERE_EXECUTION_FAILURE: 'aiProcessRuns/RETRY_STEP_FROM_HERE_EXECUTION_FAILURE',
  LOAD_FORM: 'aiProcessRuns/LOAD_FORM',
  LOAD_FORM_SUCCESS: 'aiProcessRuns/LOAD_FORM_SUCCESS',
  LOAD_FORM_FAILURE: 'aiProcessRuns/LOAD_FORM_FAILURE',
  FORM_UPSERT: 'aiProcessRuns/FORM_UPSERT',
  FORM_FIELD_SET: 'aiProcessRuns/FORM_FIELD_SET',
  FORM_STATUS_CHANGED: 'aiProcessRuns/FORM_STATUS_CHANGED',
  REVIEW_FORM_FIELD: 'aiProcessRuns/REVIEW_FORM_FIELD',
  REVIEW_FORM_FIELD_SUCCESS: 'aiProcessRuns/REVIEW_FORM_FIELD_SUCCESS',
  REVIEW_FORM_FIELD_FAILURE: 'aiProcessRuns/REVIEW_FORM_FIELD_FAILURE',
  REVIEW_FORM_FIELDS: 'aiProcessRuns/REVIEW_FORM_FIELDS',
  REVIEW_FORM_FIELDS_SUCCESS: 'aiProcessRuns/REVIEW_FORM_FIELDS_SUCCESS',
  REVIEW_FORM_FIELDS_FAILURE: 'aiProcessRuns/REVIEW_FORM_FIELDS_FAILURE',
  TRANSITION_FORM: 'aiProcessRuns/TRANSITION_FORM',
  TRANSITION_FORM_SUCCESS: 'aiProcessRuns/TRANSITION_FORM_SUCCESS',
  TRANSITION_FORM_FAILURE: 'aiProcessRuns/TRANSITION_FORM_FAILURE',
};

export const AiFormStatus = {
  DRAFTING: 'Drafting',
  READY_FOR_REVIEW: 'ReadyForReview',
  VALIDATED: 'Validated',
  APPROVED: 'Approved',
  NEEDS_REWORK: 'NeedsRework',
};

export const AiFormTransitionAction = {
  READY_FOR_REVIEW: 'ReadyForReview',
  VALIDATE: 'Validate',
  APPROVE: 'Approve',
  SEND_BACK_FOR_REWORK: 'SendBackForRework',
};

export const AiFormFieldReviewState = {
  PENDING: 'Pending',
  AGREED: 'Agreed',
  OVERRIDDEN: 'Overridden',
  FLAGGED: 'Flagged',
};

// DEV-3314 (B1) three-way income diff: each AiFormDiffRowReadModel.state. Matched
// ⇒ the AI value lines up with a loan income record; AiOnly ⇒ the AI found income
// in the docs that is not on the loan; RecordOnly ⇒ a loan income the AI never
// addressed. Serialized as PascalCase strings by the read model.
export const AiFormDiffRowState = {
  MATCHED: 'Matched',
  AI_ONLY: 'AiOnly',
  RECORD_ONLY: 'RecordOnly',
};

// DEV-3314 (B1) AiFormDiffRowReadModel.unresolvedReason: why a row could not be
// reconciled to a single loan income. Present ⇒ the row is "Unverified" and is
// ineligible for bulk agreement.
export const AiFormDiffUnresolvedReason = {
  NO_RECORD_MATCH: 'NoRecordMatch',
  BORROWER_DELETED: 'BorrowerDeleted',
  AMBIGUOUS_MATCH: 'AmbiguousMatch',
};

export const AiFormFieldProvenanceSource = {
  AI_EXTRACTED: 'AiExtracted',
  DATA_SOURCE: 'DataSource',
  MANUAL: 'Manual',
};

export const AiProcessStepConfirmationDecision = {
  CONFIRMED: 'Confirmed',
  REJECTED: 'Rejected',
};

export const ToolSlaGroupMode = {
  FIXED: 'Fixed',
  PROMPT_USER: 'PromptUser',
};

export const AiProcessExecutionStatus = {
  PENDING: 'Pending',
  RUNNING: 'Running',
  AWAITING_CONFIRMATION: 'AwaitingConfirmation',
  AWAITING_USER_INPUT: 'AwaitingUserInput',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  CANCELLED: 'Cancelled',
};

export const AiProcessStepExecutionStatus = {
  PENDING: 'Pending',
  RUNNING: 'Running',
  AWAITING_CONFIRMATION: 'AwaitingConfirmation',
  AWAITING_USER_INPUT: 'AwaitingUserInput',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  CANCELLED: 'Cancelled',
  SKIPPED: 'Skipped',
};

export const AiProcessExecutionMode = {
  SEQUENTIAL: 'Sequential',
  PARALLEL: 'Parallel',
};

export const AiProcessStepErrorReason = {
  CANCELLED: 'Cancelled',
  STOPPED_AFTER_FAILURE: 'StoppedAfterFailure',
  DEPENDENCY_OUTPUT_MISSING: 'DependencyOutputMissing',
  STEP_LOST: 'StepLost',
};

export const AiProcessAwaitingStatuses = new Set([
  AiProcessStepExecutionStatus.AWAITING_CONFIRMATION,
  AiProcessStepExecutionStatus.AWAITING_USER_INPUT,
]);

export const AiProcessExecutionLiveStatuses = new Set([
  AiProcessExecutionStatus.PENDING,
  AiProcessExecutionStatus.RUNNING,
  AiProcessExecutionStatus.AWAITING_CONFIRMATION,
  AiProcessExecutionStatus.AWAITING_USER_INPUT,
]);

export const AiProcessStepTerminalStatuses = new Set([
  AiProcessStepExecutionStatus.COMPLETED,
  AiProcessStepExecutionStatus.FAILED,
  AiProcessStepExecutionStatus.CANCELLED,
  AiProcessStepExecutionStatus.SKIPPED,
]);

export const AiProcessStepBlobKind = {
  INPUT: 'input',
  OUTPUT: 'output',
  ERROR: 'error',
};

export const LoadStatus = {
  IDLE: 'idle',
  LOADING: 'loading',
  READY: 'ready',
  ERROR: 'error',
};

const PAGE_SIZE_DEFAULT = 25;

export const RUNS_DEFAULT_PAGE_SIZE = PAGE_SIZE_DEFAULT;

export const AiProcessRunsSignalREventType = {
  EXECUTION_STARTED: 'execution_started',
  EXECUTION_COMPLETED: 'execution_completed',
  EXECUTION_FAILED: 'execution_failed',
  EXECUTION_CANCELLED: 'execution_cancelled',
  EXECUTION_AWAITING_CONFIRMATION: 'execution_awaiting_confirmation',
  STEP_STARTED: 'step_started',
  STEP_COMPLETED: 'step_completed',
  STEP_FAILED: 'step_failed',
  STEP_AWAITING_CONFIRMATION: 'step_awaiting_confirmation',
  STEP_AWAITING_USER_INPUT: 'step_awaiting_user_input',
  TOOL_STARTED: 'tool_started',
  TOOL_COMPLETED: 'tool_completed',
  TOOL_FAILED: 'tool_failed',
  TOOL_CANCELLED: 'tool_cancelled',
  TOOL_EXECUTED: 'tool_executed',
  TOOL_CONFIRMATION_REQUESTED: 'tool_confirmation_requested',
  TOOL_EXECUTION_REQUESTED: 'tool_execution_requested',
  // LEN-26: one persisted-shape transcript row pushed live as a running step
  // produces it (process runs batch-persist the transcript at step end, so
  // without this the Tool-calls tab is empty until the step completes).
  STEP_MESSAGE_APPENDED: 'step_message_appended',
  PLAN_CREATED: 'plan_created',
  PLAN_UPDATED: 'plan_updated',
  PLAN_REVISED: 'plan_revised',
  PLAN_COMPLETED: 'plan_completed',
  PLAN_CANCELLED: 'plan_cancelled',
  PLAN_STEP_STARTED: 'plan_step_started',
  PLAN_STEP_COMPLETED: 'plan_step_completed',
  PLAN_STEP_FAILED: 'plan_step_failed',
  PLAN_STEP_TOOL_DISPATCHED: 'plan_step_tool_dispatched',
  PLAN_STEP_TOOL_RETURNED: 'plan_step_tool_returned',
  RESPONSE_TOKEN: 'response_token',
  FORM_FIELD_SET: 'form_field_set',
  FORM_STATUS_CHANGED: 'form_status_changed',
};

export const AiProcessRunsSignalRMessageType = {
  JOIN_LOAN_APPLICATION: 'JoinLoanApplication',
  LEAVE_LOAN_APPLICATION: 'LeaveLoanApplication',
  JOIN_SUB_COMPANY: 'JoinSubCompany',
  LEAVE_SUB_COMPANY: 'LeaveSubCompany',
  JOIN_RATE_SHEET_UPLOAD: 'JoinRateSheetUpload',
  LEAVE_RATE_SHEET_UPLOAD: 'LeaveRateSheetUpload',
  JOIN_EXECUTION: 'JoinExecution',
  LEAVE_EXECUTION: 'LeaveExecution',
};

export const AiProcessOwnerKind = {
  LOAN_APPLICATION: 'LoanApplication',
  SUB_COMPANY: 'SubCompany',
  RATE_SHEET_UPLOAD: 'RateSheetUpload',
};

// DEV-3046: whether starting a SubCompany-scoped process offers/requires a
// certification subject set. Mirrors the BE AiProcessSubjectRequirement enum
// (serialized as strings). None ⇒ no picker; loan/contact processes are always None.
export const AiProcessSubjectRequirement = {
  NONE: 'None',
  OPTIONAL_CERTIFICATION: 'OptionalCertification',
  REQUIRED_CERTIFICATION: 'RequiredCertification',
};
